/* NAPA of Pensacola — interactions + live pool-ball hero */
(function () {
  "use strict";

  /* ---- Mobile nav ---- */
  var toggle = document.getElementById("navToggle");
  var nav = document.getElementById("primaryNav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.addEventListener("click", function (e) {
      if (e.target.tagName === "A") {
        nav.classList.remove("open");
        toggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ---- Sticky header ---- */
  var header = document.getElementById("siteHeader");
  if (header) {
    var onScroll = function () { header.classList.toggle("is-stuck", window.scrollY > 8); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Current nav item ---- */
  var page = document.body.getAttribute("data-page");
  if (page) {
    var link = document.querySelector('.nav a[data-nav="' + page + '"]');
    if (link) link.setAttribute("aria-current", "page");
  }

  /* ---- Scroll reveal ---- */
  var reveals = document.querySelectorAll(".reveal, .img-reveal");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -40px 0px" });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---- Preview forms (no backend) ---- */
  document.querySelectorAll("form[data-lead]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var note = form.querySelector(".form-status");
      var msg = form.getAttribute("data-msg") ||
        "Thanks — you're on the list. This is a preview form; on the live site this connects to the league.";
      if (note) { note.hidden = false; note.textContent = msg; note.style.color = "var(--gold-bright)"; note.style.fontWeight = "600"; }
      form.reset();
    });
  });

  /* ---- Gallery hover parity ---- */
  document.querySelectorAll(".gallery-grid .frame").forEach(function (item) {
    item.addEventListener("focus", function () { item.classList.add("is-hover"); });
    item.addEventListener("blur", function () { item.classList.remove("is-hover"); });
  });
})();

/* =====================================================================
   Live pool-ball physics — hero canvas
   Glossy numbered billiard balls drifting + colliding on the felt.
   Click/tap to break. Pauses when off-screen, tab hidden, or reduced motion.
   ===================================================================== */
(function () {
  "use strict";
  var canvas = document.getElementById("poolCanvas");
  if (!canvas) return;
  var prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var ctx = canvas.getContext("2d");
  if (!ctx) return;

  var BALLS = [
    { n: 1, c: "#E6B400" }, { n: 2, c: "#1F4FA3" }, { n: 3, c: "#C8202E" },
    { n: 4, c: "#5B2A86" }, { n: 5, c: "#E2651E" }, { n: 6, c: "#1E7A3C" },
    { n: 7, c: "#7A2231" }, { n: 8, c: "#0E0E0E" }, { n: 9, c: "#E6B400", s: 1 },
    { n: 10, c: "#1F4FA3", s: 1 }, { n: 11, c: "#C8202E", s: 1 }, { n: 12, c: "#5B2A86", s: 1 },
    { n: 13, c: "#E2651E", s: 1 }, { n: 14, c: "#1E7A3C", s: 1 }, { n: 15, c: "#7A2231", s: 1 },
    { n: 0, c: "#F2EEE2", cue: 1 }
  ];

  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0, R = 22, balls = [], running = false, raf = 0, lastGust = 0;
  var startT = null, broken = false;
  var BREAK_DELAY = 1400; // ms the rack sits racked before the cue breaks it

  function rand(a, b) { return a + Math.random() * (b - a); }

  function resize() {
    var rect = canvas.getBoundingClientRect();
    W = rect.width; H = rect.height;
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    R = Math.max(15, Math.min(30, Math.round(H * 0.046)));
    if (!balls.length) seed();
    else balls.forEach(function (b) { // keep in bounds after resize
      b.x = Math.max(R, Math.min(W - R, b.x));
      b.y = Math.max(R, Math.min(H - R, b.y));
    });
  }

  // Lay the object balls out in a triangular rack (apex on the left, pointing
  // at the cue ball) and park the cue to the left, ready to break.
  function seed() {
    balls = [];
    startT = null; broken = false;
    var count = W < 760 ? 9 : (W < 1100 ? 12 : 16);
    var nObj = count - 1;
    var pool = BALLS.slice(0, nObj);   // object balls 1..nObj
    var cueDef = BALLS[15];            // cue ball

    var gap = 2 * R + 1.4;             // centre spacing (just clear of touching → no pre-collision)
    var rowDX = gap * 0.87;            // row-to-row horizontal step of a triangular rack
    var cy = H * 0.54;

    // rows 1,2,3,… filling every object ball (last row may be partial)
    var rows = [], remaining = nObj, k = 0;
    while (remaining > 0) { var inRow = Math.min(k + 1, remaining); rows.push(inRow); remaining -= inRow; k++; }
    var nRows = rows.length;
    var rackW = (nRows - 1) * rowDX;

    // apex on the left; keep the whole rack (and room for the cue) on screen
    var apexX = W * 0.54 - rackW / 2;
    apexX = Math.max(W * 0.34, Math.min(apexX, W - rackW - R - 12));

    var idx = 0;
    for (var r = 0; r < nRows; r++) {
      var n = rows[r], rx = apexX + r * rowDX;
      for (var j = 0; j < n; j++) {
        var pb = pool[idx++];
        balls.push({
          x: rx, y: cy + (j - (n - 1) / 2) * gap, vx: 0, vy: 0,
          n: pb.n, c: pb.c, s: pb.s, cue: pb.cue, rot: rand(0, Math.PI)
        });
      }
    }
    // cue ball: left of the apex, a touch off the centre line for a lively break
    var cueX = Math.max(R + 8, apexX - Math.max(W * 0.17, 120));
    balls.push({
      x: cueX, y: cy + R * 0.45, vx: 0, vy: 0,
      n: cueDef.n, c: cueDef.c, s: cueDef.s, cue: cueDef.cue, rot: 0
    });
  }

  // Fire the cue ball straight into the apex of the rack.
  function doBreak(now) {
    broken = true;
    lastGust = now;                   // hold off the first ambient gust until ~4.2s after the break
    for (var i = 0; i < balls.length; i++) {
      if (balls[i].cue) { balls[i].vx = 15; balls[i].vy = 0; break; }
    }
  }

  function drawBall(b) {
    var x = b.x, y = b.y;
    // shadow on the felt
    ctx.beginPath();
    ctx.ellipse(x, y + R * 0.82, R * 0.96, R * 0.38, 0, 0, Math.PI * 2);
    ctx.fillStyle = "rgba(0,0,0,0.34)";
    ctx.fill();

    ctx.save();
    ctx.beginPath();
    ctx.arc(x, y, R, 0, Math.PI * 2);
    ctx.clip();

    // base
    ctx.fillStyle = b.s ? "#F3EFE4" : b.c;
    ctx.fillRect(x - R, y - R, R * 2, R * 2);

    // stripe band
    if (b.s) {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(b.rot);
      ctx.fillStyle = b.c;
      ctx.fillRect(-R, -R * 0.56, R * 2, R * 1.12);
      ctx.restore();
    }

    // number circle (skip cue)
    if (!b.cue) {
      ctx.beginPath();
      ctx.arc(x, y, R * 0.46, 0, Math.PI * 2);
      ctx.fillStyle = "#F6F2E8";
      ctx.fill();
      ctx.fillStyle = "#15110c";
      ctx.font = "700 " + (R * 0.52) + "px Oswald, Arial, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(String(b.n), x, y + R * 0.02);
    }

    // glossy highlight
    var g = ctx.createRadialGradient(x - R * 0.36, y - R * 0.42, R * 0.1, x, y, R * 1.15);
    g.addColorStop(0, "rgba(255,255,255,0.55)");
    g.addColorStop(0.18, "rgba(255,255,255,0.16)");
    g.addColorStop(0.55, "rgba(255,255,255,0)");
    g.addColorStop(1, "rgba(0,0,0,0.42)");
    ctx.fillStyle = g;
    ctx.fillRect(x - R, y - R, R * 2, R * 2);
    ctx.restore();

    // rim
    ctx.beginPath();
    ctx.arc(x, y, R, 0, Math.PI * 2);
    ctx.strokeStyle = "rgba(0,0,0,0.28)";
    ctx.lineWidth = 1;
    ctx.stroke();
    // tiny brass specular
    ctx.beginPath();
    ctx.arc(x - R * 0.34, y - R * 0.4, R * 0.13, 0, Math.PI * 2);
    ctx.fillStyle = "rgba(255,255,255,0.7)";
    ctx.fill();
  }

  function step() {
    var fr = 0.992;
    for (var i = 0; i < balls.length; i++) {
      var b = balls[i];
      b.x += b.vx; b.y += b.vy;
      b.vx *= fr; b.vy *= fr;
      // walls
      if (b.x < R) { b.x = R; b.vx = Math.abs(b.vx) * 0.86; }
      if (b.x > W - R) { b.x = W - R; b.vx = -Math.abs(b.vx) * 0.86; }
      if (b.y < R) { b.y = R; b.vy = Math.abs(b.vy) * 0.86; }
      if (b.y > H - R) { b.y = H - R; b.vy = -Math.abs(b.vy) * 0.86; }
    }
    // collisions
    for (var a = 0; a < balls.length; a++) {
      for (var c = a + 1; c < balls.length; c++) {
        var p = balls[a], q = balls[c];
        var dx = q.x - p.x, dy = q.y - p.y;
        var d2 = dx * dx + dy * dy, min = R * 2;
        if (d2 > 0 && d2 < min * min) {
          var d = Math.sqrt(d2);
          var nx = dx / d, ny = dy / d;
          var overlap = (min - d) / 2;
          p.x -= nx * overlap; p.y -= ny * overlap;
          q.x += nx * overlap; q.y += ny * overlap;
          var dvx = q.vx - p.vx, dvy = q.vy - p.vy;
          var rel = dvx * nx + dvy * ny;
          if (rel < 0) {
            var imp = rel * 0.92;
            p.vx += nx * imp; p.vy += ny * imp;
            q.vx -= nx * imp; q.vy -= ny * imp;
          }
        }
      }
    }
  }

  function render() {
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < balls.length; i++) drawBall(balls[i]);
  }

  function gust(now) {
    if (now - lastGust < 4200) return;
    lastGust = now;
    var picks = 2 + Math.floor(Math.random() * 2);
    for (var k = 0; k < picks; k++) {
      var b = balls[Math.floor(Math.random() * balls.length)];
      var a = rand(0, Math.PI * 2), mag = rand(1.4, 3.2);
      b.vx += Math.cos(a) * mag; b.vy += Math.sin(a) * mag;
    }
  }

  function loop(now) {
    if (!running) return;
    if (!prefersReduced) {
      if (startT === null) startT = now;
      if (!broken && (now - startT) >= BREAK_DELAY) doBreak(now);
      if (broken) gust(now);          // ambient gusts only start after the break
      step();
    }
    render();
    raf = requestAnimationFrame(loop);
  }

  function start() { if (running) return; running = true; raf = requestAnimationFrame(loop); }
  function stop() { running = false; if (raf) cancelAnimationFrame(raf); }

  // break from a point
  function breakFrom(px, py, power) {
    for (var i = 0; i < balls.length; i++) {
      var b = balls[i];
      var dx = b.x - px, dy = b.y - py;
      var d = Math.sqrt(dx * dx + dy * dy) || 1;
      var f = Math.max(0, (260 - d)) / 260 * power;
      b.vx += (dx / d) * f; b.vy += (dy / d) * f;
    }
  }
  canvas.addEventListener("pointerdown", function (e) {
    var rect = canvas.getBoundingClientRect();
    breakFrom(e.clientX - rect.left, e.clientY - rect.top, 9);
    broken = true;                    // a manual break counts as the break (skip the timed one)
    if (prefersReduced) { render(); }
  });

  resize();
  render();
  var rt;
  window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(resize, 200); }, { passive: true });
  document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else if (onScreen) start(); });

  var onScreen = true;
  if ("IntersectionObserver" in window && !prefersReduced) {
    var vo = new IntersectionObserver(function (ents) {
      onScreen = ents[0].isIntersecting;
      if (onScreen && !document.hidden) start(); else stop();
    }, { threshold: 0.02 });
    vo.observe(canvas);
  } else if (!prefersReduced) {
    start();
  }
})();

/* ---- Lightbox ---- */
(function () {
  "use strict";
  var triggers = document.querySelectorAll("[data-lightbox]");
  if (!triggers.length) return;
  var items = [];
  triggers.forEach(function (t) {
    var img = t.querySelector("img");
    items.push({ src: t.getAttribute("data-full") || (img && img.src), cap: t.getAttribute("data-cap") || (img && img.alt) || "" });
  });
  var box = document.createElement("div");
  box.className = "lightbox";
  box.setAttribute("role", "dialog");
  box.setAttribute("aria-modal", "true");
  box.setAttribute("aria-label", "Image viewer");
  box.innerHTML =
    '<button class="lightbox__close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
    '<button class="lightbox__nav lightbox__nav--prev" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg></button>' +
    '<button class="lightbox__nav lightbox__nav--next" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg></button>' +
    '<img alt=""><div class="lightbox__cap"></div>';
  document.body.appendChild(box);
  var imgEl = box.querySelector("img"), capEl = box.querySelector(".lightbox__cap"), idx = 0;
  function show(i) { idx = (i + items.length) % items.length; imgEl.src = items[idx].src; imgEl.alt = items[idx].cap; capEl.textContent = items[idx].cap; }
  function open(i) { show(i); box.classList.add("open"); document.body.style.overflow = "hidden"; }
  function close() { box.classList.remove("open"); document.body.style.overflow = ""; }
  triggers.forEach(function (t, i) { t.addEventListener("click", function (e) { e.preventDefault(); open(i); }); });
  box.querySelector(".lightbox__close").addEventListener("click", close);
  box.querySelector(".lightbox__nav--prev").addEventListener("click", function () { show(idx - 1); });
  box.querySelector(".lightbox__nav--next").addEventListener("click", function () { show(idx + 1); });
  box.addEventListener("click", function (e) { if (e.target === box) close(); });
  document.addEventListener("keydown", function (e) {
    if (!box.classList.contains("open")) return;
    if (e.key === "Escape") close();
    if (e.key === "ArrowLeft") show(idx - 1);
    if (e.key === "ArrowRight") show(idx + 1);
  });
})();

/* ---- Contact modal: Join the League + booking CTAs open a form (no social redirect) ---- */
(function () {
  "use strict";
  var TRIGGERS = ["join the league", "join the group", "book an hour", "book the bootcamp", "message to book", "book a session", "message"];
  var closeSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var m = document.createElement("div");
  m.className = "cmodal";
  m.hidden = true;
  m.setAttribute("role", "dialog");
  m.setAttribute("aria-modal", "true");
  m.setAttribute("aria-label", "Join the NAPA of Pensacola league");
  m.innerHTML =
    '<div class="cmodal__panel">' +
      '<button class="cmodal__close" type="button" aria-label="Close">' + closeSvg + '</button>' +
      '<span class="eyebrow">Get Started</span>' +
      '<h2>Join the League</h2>' +
      '<p>Drop your info and we’ll reach out to get you on the schedule — no Facebook account needed.</p>' +
      '<form class="cform" novalidate>' +
        '<div class="field"><label for="cf-name">Name</label><input id="cf-name" name="name" autocomplete="name" required></div>' +
        '<div class="field"><label for="cf-email">Email</label><input id="cf-email" name="email" type="email" autocomplete="email" required></div>' +
        '<div class="field"><label for="cf-phone">Phone</label><input id="cf-phone" name="phone" type="tel" autocomplete="tel"></div>' +
        '<div class="field"><label for="cf-msg">What are you interested in?</label><textarea id="cf-msg" name="message" placeholder="Joining the league, a lesson, the 3-hour bootcamp…"></textarea></div>' +
        '<button class="btn btn--primary btn--block" type="submit">Send Request</button>' +
        '<p class="cform__status" role="status" hidden></p>' +
      '</form>' +
    '</div>';
  document.body.appendChild(m);
  var form = m.querySelector(".cform");
  var status = m.querySelector(".cform__status");
  var lastFocus = null;
  function open(e) { if (e) e.preventDefault(); lastFocus = document.activeElement; m.hidden = false; document.body.style.overflow = "hidden"; var f = m.querySelector("input, textarea"); if (f) f.focus(); }
  function close() { m.hidden = true; document.body.style.overflow = ""; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  m.addEventListener("click", function (e) { if (e.target === m) close(); });
  m.querySelector(".cmodal__close").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (!m.hidden && e.key === "Escape") close(); });
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (status) { status.hidden = false; status.textContent = "Thanks — your request is in! We’ll reach out shortly to get you on the schedule."; }
    form.reset();
  });
  document.querySelectorAll("a.btn").forEach(function (a) {
    var t = (a.textContent || "").trim().toLowerCase();
    if (TRIGGERS.indexOf(t) !== -1) a.addEventListener("click", open);
  });
})();
